const EVENTS = {

    APPLICATION_LOADED: 'application.loaded',
    APPLICATION_RELOAD: 'application.reload',

    HISTORY_PUSH: 'window.history.push',
    STATE_CHANGE: 'state.change',
    VIEWPORT_CHANGE: 'viewport.change',
    VIEWPORT_RESIZE: 'viewport.resized',

    POPUP_SHOW: 'popup.show',
    POPUP_HIDE: 'popup.hide',

    MODAL_OPEN: 'modal.open',
    MODAL_CLOSED: 'modal.closed',

    LANGUAGE_SWITCHER_OPEN: 'language-switcher.open',
    LANGUAGE_SWITCHER_CLOSE: 'language-switcher.close',

    MENU_OPEN: 'menu.open',
    MENU_CLOSE: 'menu.close',
};

export default EVENTS;
